/* La NATURE d'un compte dans les listes de contreparties (2026-10-20) : un poste
   du bilan se lit « Actif » ou « Passif » (les capitaux propres sont au passif),
   une ligne du compte de résultat « Compte de résultat ». */
const ASSET_SECTIONS = ['current_assets', 'fixed_assets'];

export const bsNature = (section, p) => (ASSET_SECTIONS.includes(section) ? p('Actif') : p('Passif'));
export const plNature = (p) => p('Compte de résultat');

/* La liste des comptes à choisir, un intertitre par section dans l'ordre du
   compte de résultat puis du bilan ; chaque libellé garde sa nature pour se
   lire une fois choisi. Elle sert les deux cartes des Opérations spéciales. */
export function accountOptions(plLines, bsLines, p) {
  const out = [];
  const add = (lines, natureOf) => {
    let last = null;
    lines.forEach((l) => {
      const head = l.section_label || l.section;
      if (head !== last) { out.push({ group: head }); last = head; }
      out.push({ value: l.id, label: `${natureOf(l)} · ${l.label}` });
    });
  };
  add(plLines, () => plNature(p));
  add(bsLines, (l) => bsNature(l.section, p));
  return out;
}
